exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element--list{-ms-touch-action:pan-y;touch-action:pan-y}", ""]);

// exports
